'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getSeparatorIndexes(children) {
  return children.reduce(function (acc, child, index) {
    if (child === '-' || child.props && child.props.isSeparator) {
      acc.push(index);
    }
    return acc;
  }, []);
}

exports.default = getSeparatorIndexes;